const Spinner = {
  baseStyle: {
    color: "primary.500",
  },
};

export default Spinner;
